export type ClassValue = string | false | null | undefined;

/** Junta classes condicionais (clsx minimalista). */
export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
